"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SweetAlertStyles_1 = require("../styles/SweetAlertStyles");
var Title = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("h2", { style: SweetAlertStyles_1.title }, children);
};
exports.default = Title;
//# sourceMappingURL=Title.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-sweetalert/dist/components/Title.js
// module id = 2096
// module chunks = 0